module.exports = "/packs/course-small-self-branding-9b58d62a1a0339dad4a4a3f58cc3a67b.png";